// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ant-dropdown-menu {
  background: var(--bg-elevated) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-md) !important;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45) !important;
  padding: 8px !important;
  min-width: 220px;
}
.ant-dropdown-menu-item {
  border-radius: var(--radius-sm) !important;
  margin: 2px 0 !important;
  color: var(--text-secondary) !important;
  transition: all 0.15s ease !important;
}
.ant-dropdown-menu-item:hover {
  background: var(--bg-hover) !important;
  color: var(--text-primary) !important;
}
.ant-dropdown-menu-item-disabled,
.ant-dropdown-menu-item-disabled:hover {
  background: transparent !important;
  cursor: default !important;
}
.ant-dropdown-menu-item-divider { background: var(--border) !important; }
.ant-dropdown-menu-item-danger { color: var(--danger) !important; }
.ant-dropdown-menu .ant-dropdown-menu-item:not(.ant-dropdown-menu-item-danger) .ant-dropdown-menu-title-content {
  color: var(--text-secondary) !important;
}
.ant-dropdown-menu .ant-dropdown-menu-item:not(.ant-dropdown-menu-item-danger):hover .ant-dropdown-menu-title-content {
  color: var(--text-primary) !important;
}
.ant-dropdown-menu-item-danger:hover {
  background: var(--danger-bg) !important;
  color: var(--danger) !important;
}
.ant-dropdown-menu-item .anticon,
.ant-dropdown-menu-item svg {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,qDAAqD;EACrD,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;AACA;;EAEE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA,kCAAkC,oCAAoC,EAAE;AACxE,iCAAiC,+BAA+B,EAAE;AAClE;EACE,uCAAuC;AACzC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;AACA;;EAEE,WAAW;EACX,YAAY;AACd","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ant-dropdown-menu {\n  background: var(--bg-elevated) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-md) !important;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45) !important;\n  padding: 8px !important;\n  min-width: 220px;\n}\n.ant-dropdown-menu-item {\n  border-radius: var(--radius-sm) !important;\n  margin: 2px 0 !important;\n  color: var(--text-secondary) !important;\n  transition: all 0.15s ease !important;\n}\n.ant-dropdown-menu-item:hover {\n  background: var(--bg-hover) !important;\n  color: var(--text-primary) !important;\n}\n.ant-dropdown-menu-item-disabled,\n.ant-dropdown-menu-item-disabled:hover {\n  background: transparent !important;\n  cursor: default !important;\n}\n.ant-dropdown-menu-item-divider { background: var(--border) !important; }\n.ant-dropdown-menu-item-danger { color: var(--danger) !important; }\n.ant-dropdown-menu .ant-dropdown-menu-item:not(.ant-dropdown-menu-item-danger) .ant-dropdown-menu-title-content {\n  color: var(--text-secondary) !important;\n}\n.ant-dropdown-menu .ant-dropdown-menu-item:not(.ant-dropdown-menu-item-danger):hover .ant-dropdown-menu-title-content {\n  color: var(--text-primary) !important;\n}\n.ant-dropdown-menu-item-danger:hover {\n  background: var(--danger-bg) !important;\n  color: var(--danger) !important;\n}\n.ant-dropdown-menu-item .anticon,\n.ant-dropdown-menu-item svg {\n  width: 16px;\n  height: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
